import { useLyftSocket } from '@src/hooks';
import { isChatOpenStatus } from '@component/DriverChat/helpers';

type LiveChatStatus = {
  statusId: number | null;
  /** True once the driver has accepted and the ride is still in progress. */
  isChatOpen: boolean;
};

/** Pure form, so a list can resolve many segments from one `socketStatus` read. */
export const resolveChatStatus = (
  socketStatus: Record<number, { statusId?: number }> | undefined,
  segmentId: number,
  fallbackStatusId?: number | null,
  conversationStatus?: string
): LiveChatStatus => {
  const live = socketStatus?.[segmentId]?.statusId;
  const statusId: number | null = live ?? fallbackStatusId ?? null;

  return {
    statusId,
    isChatOpen:
      conversationStatus !== 'COMPLETED' &&
      (statusId == null
        ? conversationStatus === 'ACTIVE'
        : isChatOpenStatus(statusId)),
  };
};

/**
 * The chat shows the exact ride status the rest of the app shows: the live
 * `socketStatus` kept by LyftProvider. The server value is only a fallback
 * for the moment before the first socket event arrives.
 */
export const useLiveChatStatus = (
  segmentId: number,
  fallbackStatusId?: number | null,
  conversationStatus?: string
): LiveChatStatus => {
  const { socketStatus } = useLyftSocket();
  return resolveChatStatus(
    socketStatus,
    segmentId,
    fallbackStatusId,
    conversationStatus
  );
};
